<template>
  <qc-container :title="title">
    <page-request ref="table" url="/api/mgr/business/shop/list" :table-header="type===0?tableHeader:tableHeader1" :expend="expend" :prop="{type:type}" :op-width="200">
      <t-button @click="toEdit()">添加</t-button>
      <t-button @click="batchUpdateStatus(0)">批量启用</t-button>
      <t-button @click="batchUpdateStatus(1)">批量禁用</t-button>
      <template #op="scope">
        <b-button @click="toDetail(scope.row)">查看</b-button>
        <b-button @click="toEdit(scope.row)">编辑</b-button>
        <b-button @click="resetPass(scope.row)">重置密码</b-button>
        <template v-if="type===0">
          <b-button v-if="scope.row.status===0" @click="updateStatus([scope.row.id],1)">启用</b-button>
          <b-button v-if="scope.row.status===1" @click="updateStatus([scope.row.id],0)">禁用</b-button>
        </template>
        <template v-if="type===1">
          <b-button v-if="scope.row.status===0" @click="updateStatus([scope.row.id],1)">禁用</b-button>
          <b-button v-if="scope.row.status===1" @click="updateStatus([scope.row.id],0)">启用</b-button>
        </template>
<!--        <b-button @click="doDel(scope.row)">删除</b-button>-->
      </template>
    </page-request>
    <reset-shop-pass ref="reset"></reset-shop-pass>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import ResetShopPass from "@view/store/op/reset-shop-pass.vue";

export default {
  props:{
    title:String,
    //类型 0加盟商 1门店
    type:{
      type:Number,
      default:0
    }
  },
  name: "shop-list",
  components: {ResetShopPass, PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {type: "shop", label: "商家",minWidth:200},
        {prop: "goodsCount", label: "商品数",width: 100},
        {prop: "orderCount", label: "订单数",width: 100},
        {prop: "turnover", label: "销售额",width: 100},
        {prop: "money", label: "余额",width: 100},
        {label: "状态",renderDraw:row=>{
            return row.status?"正常":"禁用";
          },width: 100},
        {prop: "lastLoginTime", label: "最近登录时间",width: 160},
        {prop: "createTime", label: "注册时间",width: 160}
      ],
      tableHeader1: [
        {type: "selection", label: ""},
        {type: "shop", label: "商家",minWidth:200},
        {prop: "orderCount", label: "订单数",width: 100},
        {prop: "turnover", label: "销售额",width: 100},
        {prop: "money", label: "余额",width: 100},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "lastLoginTime", label: "最近登录时间",width: 160},
        {prop: "createTime", label: "注册时间",width: 160}
      ],
      expend:[
        {label: "商家名称",prop: "name"},
        {label: "商家ID",prop: "code"},
        {label: "手机号码",prop: "mobile"},
        {label: "商家状态", prop: "status",type:"dict",dictType:"shopStatus"},
        {label: "登录时间", start: "lastLoginTimeStart", end: "lastLoginTimeEnd", type: "daterange"},
        {label: "注册时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    resetPass(row){
      this.$refs.reset.openDialog(row.id);
    },
    toEdit(row){
      if(this.type===0){
        this.toRouter("/index/franchisee/add",row?{id:row.id}:{})
      }else{
        this.toRouter("/index/store/add",row?{id:row.id}:{})
      }
    },
    batchUpdateStatus(status) {
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.updateStatus(ids,status);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    updateStatus(ids,status){
      this.msgConfirm("/api/mgr/business/shop/updateStatus",{ids:ids,status:status},()=>{
        this.pageReloadData();
      },`您是否要${status?'禁用':'启用'}所选商户?`)
    },
    toDetail(row){
      if(this.type===0){
        this.toRouter("/index/franchisee/detail",{id:row.id})
      }else{
        this.toRouter("/index/store/detail",{id:row.id})
      }
    },
    doDel(row){
      this.msgConfirm("/api/mgr/business/shop/delete",{id:row.id},()=>{
        this.pageReloadData();
      })
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
